import * as Types from '../../../types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type OpusAgentAttachmentMediaFragment = { __typename?: 'Media', id: number, thumbnailImageUrl?: string | null, mediaUrls: { __typename?: 'TranslationSet', uuid: string, en: string }, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, thumb?: string | null } | null };

export type OpusAgentAttachment_TrainingResourceVersionFragment = { __typename?: 'TrainingResourceVersion', id: string, type: Types.TrainingResourceVersionType, media?: { __typename?: 'Media', id: number, thumbnailImageUrl?: string | null, mediaUrls: { __typename?: 'TranslationSet', uuid: string, en: string }, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, thumb?: string | null } | null } | null };

export type OpusAgentAttachmentLibraryItemFragment = { __typename?: 'LibraryItem', id: string, type: Types.LibraryItemType, name: { __typename?: 'TranslationSet', uuid: string, en: string }, coverImage?: { __typename?: 'CoverImage', id: string, emojiIcon?: string | null, background?: Types.BackgroundGradient | null, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, thumb?: string | null } | null } | null, trainingResource?: { __typename?: 'TrainingResource', id: string, draftVersion: { __typename?: 'TrainingResourceVersion', id: string, type: Types.TrainingResourceVersionType, media?: { __typename?: 'Media', id: number, thumbnailImageUrl?: string | null, mediaUrls: { __typename?: 'TranslationSet', uuid: string, en: string }, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, thumb?: string | null } | null } | null }, publishedVersion?: { __typename?: 'TrainingResourceVersion', id: string, type: Types.TrainingResourceVersionType, media?: { __typename?: 'Media', id: number, thumbnailImageUrl?: string | null, mediaUrls: { __typename?: 'TranslationSet', uuid: string, en: string }, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, thumb?: string | null } | null } | null } | null } | null };

export type OpusAgentTurnAttachmentFieldsFragment = { __typename?: 'OpusAgentTurnAttachment', id: string, index: number, media?: { __typename?: 'Media', id: number, thumbnailImageUrl?: string | null, mediaUrls: { __typename?: 'TranslationSet', uuid: string, en: string }, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, thumb?: string | null } | null } | null, libraryItem?: { __typename?: 'LibraryItem', id: string, type: Types.LibraryItemType, name: { __typename?: 'TranslationSet', uuid: string, en: string }, coverImage?: { __typename?: 'CoverImage', id: string, emojiIcon?: string | null, background?: Types.BackgroundGradient | null, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, thumb?: string | null } | null } | null, trainingResource?: { __typename?: 'TrainingResource', id: string, draftVersion: { __typename?: 'TrainingResourceVersion', id: string, type: Types.TrainingResourceVersionType, media?: { __typename?: 'Media', id: number, thumbnailImageUrl?: string | null, mediaUrls: { __typename?: 'TranslationSet', uuid: string, en: string }, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, thumb?: string | null } | null } | null }, publishedVersion?: { __typename?: 'TrainingResourceVersion', id: string, type: Types.TrainingResourceVersionType, media?: { __typename?: 'Media', id: number, thumbnailImageUrl?: string | null, mediaUrls: { __typename?: 'TranslationSet', uuid: string, en: string }, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, thumb?: string | null } | null } | null } | null } | null } | null };

export type OpusAgentAttachmentStatusFieldsFragment = { __typename?: 'OpusAgentAttachmentStatus', mediaId?: number | null, libraryItemId?: string | null, state: Types.OpusAgentAttachmentState, detail?: string | null, phase: Types.OpusAgentAttachmentPhase, progressDone?: number | null, progressTotal?: number | null, pageCount?: number | null, textFound?: boolean | null };

export type OpusAgentAttachmentCreateMediaMutationVariables = Types.Exact<{
  input: Types.MediaInput;
}>;


export type OpusAgentAttachmentCreateMediaMutation = { __typename?: 'Mutation', createMedia: { __typename?: 'MediaMutationResult', success: boolean, error?: { __typename?: 'Error', code: string, message?: string | null } | null, media?: { __typename?: 'Media', id: number, thumbnailImageUrl?: string | null, mediaUrls: { __typename?: 'TranslationSet', uuid: string, en: string }, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, thumb?: string | null } | null } | null } };

export type StartOpusAgentAttachmentsMutationVariables = Types.Exact<{
  input: Array<Types.OpusAgentAttachmentInput> | Types.OpusAgentAttachmentInput;
}>;


export type StartOpusAgentAttachmentsMutation = { __typename?: 'Mutation', startOpusAgentAttachments: { __typename?: 'StartOpusAgentAttachmentsResult', success: boolean, error?: { __typename?: 'Error', code: string, message?: string | null } | null, statuses?: Array<{ __typename?: 'OpusAgentAttachmentStatus', mediaId?: number | null, libraryItemId?: string | null, state: Types.OpusAgentAttachmentState, detail?: string | null, phase: Types.OpusAgentAttachmentPhase, progressDone?: number | null, progressTotal?: number | null, pageCount?: number | null, textFound?: boolean | null }> | null } };

export type OpusAgentAttachmentStatusesQueryVariables = Types.Exact<{
  input: Array<Types.OpusAgentAttachmentInput> | Types.OpusAgentAttachmentInput;
}>;


export type OpusAgentAttachmentStatusesQuery = { __typename?: 'Query', OpusAgentAttachmentStatuses: Array<{ __typename?: 'OpusAgentAttachmentStatus', mediaId?: number | null, libraryItemId?: string | null, state: Types.OpusAgentAttachmentState, detail?: string | null, phase: Types.OpusAgentAttachmentPhase, progressDone?: number | null, progressTotal?: number | null, pageCount?: number | null, textFound?: boolean | null }> };

export const OpusAgentAttachmentMediaFragmentDoc = gql`
    fragment OpusAgentAttachmentMedia on Media {
  id
  thumbnailImageUrl
  mediaUrls {
    uuid
    en
  }
  imageUrls {
    id
    original
    thumb
  }
}
    `;
export const OpusAgentAttachment_TrainingResourceVersionFragmentDoc = gql`
    fragment OpusAgentAttachment_TrainingResourceVersion on TrainingResourceVersion {
  id
  type
  media {
    ...OpusAgentAttachmentMedia
  }
}
    ${OpusAgentAttachmentMediaFragmentDoc}`;
export const OpusAgentAttachmentLibraryItemFragmentDoc = gql`
    fragment OpusAgentAttachmentLibraryItem on LibraryItem {
  id
  type
  name {
    uuid
    en
  }
  coverImage {
    id
    emojiIcon
    background
    imageUrls {
      id
      original
      thumb
    }
  }
  trainingResource {
    id
    draftVersion {
      ...OpusAgentAttachment_TrainingResourceVersion
    }
    publishedVersion {
      ...OpusAgentAttachment_TrainingResourceVersion
    }
  }
}
    ${OpusAgentAttachment_TrainingResourceVersionFragmentDoc}`;
export const OpusAgentTurnAttachmentFieldsFragmentDoc = gql`
    fragment OpusAgentTurnAttachmentFields on OpusAgentTurnAttachment {
  id
  index
  media {
    ...OpusAgentAttachmentMedia
  }
  libraryItem {
    ...OpusAgentAttachmentLibraryItem
  }
}
    ${OpusAgentAttachmentMediaFragmentDoc}
${OpusAgentAttachmentLibraryItemFragmentDoc}`;
export const OpusAgentAttachmentStatusFieldsFragmentDoc = gql`
    fragment OpusAgentAttachmentStatusFields on OpusAgentAttachmentStatus {
  mediaId
  libraryItemId
  state
  detail
  phase
  progressDone
  progressTotal
  pageCount
  textFound
}
    `;
export const OpusAgentAttachmentCreateMediaDocument = gql`
    mutation OpusAgentAttachmentCreateMedia($input: MediaInput!) {
  createMedia(input: $input) {
    success
    error {
      code
      message
    }
    media {
      ...OpusAgentAttachmentMedia
    }
  }
}
    ${OpusAgentAttachmentMediaFragmentDoc}`;
export type OpusAgentAttachmentCreateMediaMutationFn = Apollo.MutationFunction<OpusAgentAttachmentCreateMediaMutation, OpusAgentAttachmentCreateMediaMutationVariables>;

/**
 * __useOpusAgentAttachmentCreateMediaMutation__
 *
 * To run a mutation, you first call `useOpusAgentAttachmentCreateMediaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOpusAgentAttachmentCreateMediaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [opusAgentAttachmentCreateMediaMutation, { data, loading, error }] = useOpusAgentAttachmentCreateMediaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOpusAgentAttachmentCreateMediaMutation(baseOptions?: Apollo.MutationHookOptions<OpusAgentAttachmentCreateMediaMutation, OpusAgentAttachmentCreateMediaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OpusAgentAttachmentCreateMediaMutation, OpusAgentAttachmentCreateMediaMutationVariables>(OpusAgentAttachmentCreateMediaDocument, options);
      }
export type OpusAgentAttachmentCreateMediaMutationHookResult = ReturnType<typeof useOpusAgentAttachmentCreateMediaMutation>;
export type OpusAgentAttachmentCreateMediaMutationResult = Apollo.MutationResult<OpusAgentAttachmentCreateMediaMutation>;
export type OpusAgentAttachmentCreateMediaMutationOptions = Apollo.BaseMutationOptions<OpusAgentAttachmentCreateMediaMutation, OpusAgentAttachmentCreateMediaMutationVariables>;
export const StartOpusAgentAttachmentsDocument = gql`
    mutation StartOpusAgentAttachments($input: [OpusAgentAttachmentInput!]!) {
  startOpusAgentAttachments(input: $input) {
    success
    error {
      code
      message
    }
    statuses {
      ...OpusAgentAttachmentStatusFields
    }
  }
}
    ${OpusAgentAttachmentStatusFieldsFragmentDoc}`;
export type StartOpusAgentAttachmentsMutationFn = Apollo.MutationFunction<StartOpusAgentAttachmentsMutation, StartOpusAgentAttachmentsMutationVariables>;

/**
 * __useStartOpusAgentAttachmentsMutation__
 *
 * To run a mutation, you first call `useStartOpusAgentAttachmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartOpusAgentAttachmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startOpusAgentAttachmentsMutation, { data, loading, error }] = useStartOpusAgentAttachmentsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartOpusAgentAttachmentsMutation(baseOptions?: Apollo.MutationHookOptions<StartOpusAgentAttachmentsMutation, StartOpusAgentAttachmentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartOpusAgentAttachmentsMutation, StartOpusAgentAttachmentsMutationVariables>(StartOpusAgentAttachmentsDocument, options);
      }
export type StartOpusAgentAttachmentsMutationHookResult = ReturnType<typeof useStartOpusAgentAttachmentsMutation>;
export type StartOpusAgentAttachmentsMutationResult = Apollo.MutationResult<StartOpusAgentAttachmentsMutation>;
export type StartOpusAgentAttachmentsMutationOptions = Apollo.BaseMutationOptions<StartOpusAgentAttachmentsMutation, StartOpusAgentAttachmentsMutationVariables>;
export const OpusAgentAttachmentStatusesDocument = gql`
    query OpusAgentAttachmentStatuses($input: [OpusAgentAttachmentInput!]!) {
  OpusAgentAttachmentStatuses(input: $input) {
    ...OpusAgentAttachmentStatusFields
  }
}
    ${OpusAgentAttachmentStatusFieldsFragmentDoc}`;

/**
 * __useOpusAgentAttachmentStatusesQuery__
 *
 * To run a query within a React component, call `useOpusAgentAttachmentStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpusAgentAttachmentStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpusAgentAttachmentStatusesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOpusAgentAttachmentStatusesQuery(baseOptions: Apollo.QueryHookOptions<OpusAgentAttachmentStatusesQuery, OpusAgentAttachmentStatusesQueryVariables> & ({ variables: OpusAgentAttachmentStatusesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OpusAgentAttachmentStatusesQuery, OpusAgentAttachmentStatusesQueryVariables>(OpusAgentAttachmentStatusesDocument, options);
      }
export function useOpusAgentAttachmentStatusesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OpusAgentAttachmentStatusesQuery, OpusAgentAttachmentStatusesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OpusAgentAttachmentStatusesQuery, OpusAgentAttachmentStatusesQueryVariables>(OpusAgentAttachmentStatusesDocument, options);
        }
export type OpusAgentAttachmentStatusesQueryHookResult = ReturnType<typeof useOpusAgentAttachmentStatusesQuery>;
export type OpusAgentAttachmentStatusesLazyQueryHookResult = ReturnType<typeof useOpusAgentAttachmentStatusesLazyQuery>;
export type OpusAgentAttachmentStatusesQueryResult = Apollo.QueryResult<OpusAgentAttachmentStatusesQuery, OpusAgentAttachmentStatusesQueryVariables>;